import React, { forwardRef } from "react";
import Flatpickr from "react-flatpickr";

const FlatpickrField = forwardRef((props: any, ref: any) => {
  return (
    <>
      <div className="form-floating w-100">
        <Flatpickr
          {...props}
          ref={ref}
          className={`form-control ${props.className || ""}`}
        />
        <label htmlFor="floatingInput">{props?.placeholder}</label>
      </div>
    </>
  );
});

export default FlatpickrField;
